import React from 'react';
import { 
  TextField as MUITextField, 
  TextFieldProps as MUITextFieldProps,
  styled,
  InputAdornment
} from '@mui/material';

export interface TextFieldProps extends Omit<MUITextFieldProps, 'variant'> {
  /** Input label */
  label?: string;
  /** Helper text shown below the input */
  helperText?: React.ReactNode;
  /** Error state */
  error?: boolean;
  /** Error message */
  errorText?: string;
  /** Start adornment (icon or text at start of input) */
  startAdornment?: React.ReactNode;
  /** End adornment (icon or text at end of input) */
  endAdornment?: React.ReactNode;
  /** Full width input */
  fullWidth?: boolean;
  /** Controlled input value */
  value?: string | number;
  /** Input change handler */
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const StyledTextField = styled(MUITextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius,
  },
}));

export const TextField: React.FC<TextFieldProps> = ({
  label,
  helperText,
  error = false,
  errorText,
  startAdornment,
  endAdornment,
  fullWidth = true,
  ...rest
}) => {
  const displayHelperText = error && errorText ? errorText : helperText;
  
  return (
    <StyledTextField
      label={label}
      error={error}
      helperText={displayHelperText}
      fullWidth={fullWidth}
      InputProps={{
        startAdornment: startAdornment && (
          <InputAdornment position="start">{startAdornment}</InputAdornment>
        ),
        endAdornment: endAdornment && (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ),
      }}
      variant="outlined"
      {...rest}
    />
  );
};

export default TextField;
